import moment from "moment";
import React, { useState } from "react";
import { Spinner } from "react-bootstrap";
import { FaCheckCircle } from "react-icons/fa";
import { IoCheckmarkCircle, IoCopyOutline } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";
import { useEnrollClassMutation } from "../../Data/services/classesApi";
import { ErrorToast, SuccessToast } from "../../Hooks/useToast";
import { Button } from "../CustomComponents";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/LocationModal.module.scss";
import { BsFillCheckCircleFill } from "react-icons/bs";

const LocationModal = ({ handleModalClose, data, hasAccess = true, isAttendSubmitted = false, handleAttendClass }) => {
  const [copied, setCopied] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [enrollClass] = useEnrollClassMutation();

  const handleCopyClick = () => {
    const mapLink = `https://www.google.com/maps/search/?api=1&query=${data?.latitude},${data?.longitude}`
    navigator.clipboard.writeText(mapLink).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset copied state after 2 seconds
    });
  };


  const handleEnrollClass = async () => {
    if (isLoading) return;
    try {
      setIsLoading(true)
      await enrollClass({ class_id: data?.id }).unwrap()
      SuccessToast("Successfully enrolled in class")
      handleModalClose()
    }
    catch (err) {
      ErrorToast(err.data?.message || "Something went wrong. Please try again later")
      setIsLoading(false)
    }
  }


  return (
    <div>
      <ModalContainer handleClose={handleModalClose}>
        <div className={cssStyles.modalContainer}>
          <span
            className={`bg-category-bg shadow d-flex p-2 rounded-5 ${cssStyles.closeBtn}`}
          >
            <RxCross2
              role="button"
              onClick={handleModalClose}
              style={{ cursor: "pointer" }}
            />
          </span>
          <div className="d-flex  align-items-center w-100 justify-content-between ">
            <p className="fs-2 fw-bold fw-medium m-auto">{data?.title}</p>
          </div>

          <div className="d-flex flex-column justify-content-between align-items-center">
            <div className="fs-6 primary-bg rounded-5 px-3 py-1 text-white m-2">
              You have Attend Online Class
            </div>

            <div
              className="d-flex flex-column justify-content-center grayBg rounded-5 my-2"
              style={{ width: "400px" }}
            >
              <img
                src={"/images/location_image.png"}
                alt="Logo"
                className={cssStyles.locationImage}
              />

              <div className="p-3">
                <div className="fs-4 fw-bold">{data?.event_name}</div>
                <div className="fs-8 fw-light">
                  <img
                    alt="visit video"
                    src="/images/map_black.svg"
                    width={16}
                    className="me-1"
                  />
                  {data?.location}
                </div>

                <div className="d-flex flex-wrap justify-content-center w-100 mx-auto">
                  <div className="p-2 px-2 m-2 ms-0 me-auto rounded-4 bg-white fs-6 fw-light">
                    <img
                      alt="visit video"
                      src="/images/watch.svg"
                      width={24}
                      className="me-2"
                    />
                    {moment(data?.start_at)?.format('hh:mm A')}
                  </div>

                  <div className="p-2 px-2 m-2 ms-0 me-auto rounded-4 bg-white fs-6 fw-light">
                    <img
                      alt="visit video"
                      src="/images/calendar.svg"
                      width={24}
                      className="me-2"
                    />
                    {moment(data?.start_at)?.format('dddd DD MMM, YYYY')}
                  </div>
                </div>
              </div>
            </div>

            <div className="fs-4 fw-light mt-2">Google Direction</div>

            <div className="p-2 px-3 m-2 rounded-4 grayBg fs-5 d-flex align-items-center">
              <img
                alt="visit video"
                src="/images/map.svg"
                width={30}
                className="me-2"
              />
              <span className="px-2 fs-7 d-flex">{data?.location}</span>
              {
                //   <img
                //   alt="visit video"
                //   src="/images/copy.svg"
                //   width={25}
                //   className="ms-2"
                //   style={{ cursor: "pointer" }}
                //   onClick={handleCopyClick}
                // />
              }
              {copied ? (
                <FaCheckCircle size={20} color="green" className="ms-2" />
              ) : (
                <IoCopyOutline
                  size={20}
                  className="ms-2 icon-fade"
                  style={{ cursor: "pointer" }}
                  onClick={handleCopyClick}
                />
              )}
            </div>
            {
              // copied && <span className="ms-2 text-success">Copied!</span>
            }

            {
              data?.is_completed ?
                <Button
                  text={<span className="d-flex align-items-center justify-content-center gap-2">Completed<IoCheckmarkCircle size={25} /></span>}
                  classes="gradientBg rounded-5 fw-bold mt-3"
                /> :
                data?.is_enrolled ?
                  <Button
                    classes="gradientBg rounded-5 fw-bold mt-3"
                    onClick={handleAttendClass}
                    text={
                      isAttendSubmitted ? <Spinner /> :
                        <div>
                          <BsFillCheckCircleFill size={24} /> Attend
                        </div>
                    }
                  /> :
                  !hasAccess ? <p className="my-4">Already Enrolled In Another Class</p> :
                    <Button
                      text={isLoading ? <Spinner color="white" /> : "Enroll now"}
                      classes="gradientBg rounded-5 fw-bold mt-3"
                      onClick={handleEnrollClass}
                    />
            }
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default LocationModal;
